import { Component, OnInit } from '@angular/core'
import { Classification } from '@spartacus/core'
import { CurrentProductService } from '@spartacus/storefront'
import { Observable } from 'rxjs'
import { ICustomProduct } from '../../../models/interface/product.interface'
import { ProductDetailsService } from '../../../services/product.service'

@Component({
    selector: 'app-product-specs-tab',
    templateUrl: './product-specs-tab.component.html',
    styleUrls: ['./product-specs-tab.component.scss'],
    standalone: false
})
export class ProductSpecsTabComponent implements OnInit {
  // product$: Observable<ICustomProduct> = this.productDetailsService.getProductDetail$();

  product$: Observable<ICustomProduct>

  //  product$: Observable<ICustomProduct> = this.productDetailsService.getProductDetail$();

  constructor(
    protected currentProductService: CurrentProductService,
    private productDetailsService: ProductDetailsService
  ) {}

  ngOnInit(): void {
    this.product$ = this.productDetailsService.getProductDetail$()
  }

  public filterClassifications(classification: Classification): boolean {
    if (
      classification.code === 'consumerUnits' ||
      classification.code === 'transportUnits' ||
      classification.code === 'aupallet' ||
      classification.code === 'nzpallet'
    ) {
      return true
    } else {
      return false
    }
  }
}
